const features = [
  {
    icon: "ri-lock-password-line",
    title: "AES-256 Encryption",
    desc: "Bank-grade cryptographic protocols protect every byte of data you send or receive, making interception virtually impossible.",
  },
  {
    icon: "ri-eye-off-line",
    title: "Strict Zero-Log Policy",
    desc: "We never track, store, or sell your browsing activity. Your online behavior is your own — full stop.",
  },
  {
    icon: "ri-global-line",
    title: "40+ Server Locations",
    desc: "Connect through a global network of high-speed servers and access the content you want from anywhere in the world.",
  },
  {
    icon: "ri-flashlight-line",
    title: "Lightning-Fast Speeds",
    desc: "Optimized tunneling protocols ensure minimal latency so your VPN connection never slows you down.",
  },
  {
    icon: "ri-wifi-line",
    title: "Public Wi-Fi Shield",
    desc: "Automatically secure your connection the moment you join any public hotspot — airports, cafes, hotels.",
  },
  {
    icon: "ri-toggle-line",
    title: "Kill Switch",
    desc: "If the VPN connection drops, all internet traffic is instantly cut to prevent any accidental data exposure.",
  },
];

export default function VpnSection() {
  return (
    <section id="vpn" className="py-24 md:py-36 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Top grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-20 md:mb-28">
          {/* Text */}
          <div>
            <span className="text-xs uppercase tracking-[0.3em] text-gray-400 font-medium mb-4 block">
              / Product 01 /
            </span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight tracking-tight mb-6">
              MAHHERC VPN
              <br />
              <span className="text-gray-300">Your Privacy, Protected</span>
            </h2>
            <p className="text-gray-500 text-base md:text-lg leading-relaxed mb-8">
              In an age where digital privacy is under constant threat,
              MAHHERC VPN gives you back control. Designed natively for iOS,
              it wraps every connection in impenetrable encryption — whether
              you are at home, at the office, or on the go.
            </p>
            <div className="flex flex-wrap gap-3">
              {["Privacy", "Security", "Freedom"].map((t) => (
                <span
                  key={t}
                  className="border border-gray-200 rounded-full px-4 py-2 text-xs text-gray-500 uppercase tracking-widest"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="relative flex justify-center lg:justify-end">
            <div className="relative w-64 md:w-80 rounded-[40px] overflow-hidden border border-gray-100">
              <img
                src="https://public.readdy.ai/ai/img_res/0e20ab583282dcd131677dbea83e805e.jpg"
                alt="MAHHERC VPN app interface"
                className="w-full h-auto object-cover object-top"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute top-8 -left-4 bg-[#0f0f0f] rounded-2xl px-4 py-3 flex items-center gap-3">
              <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
              <span className="text-white text-xs font-medium whitespace-nowrap">Connected &amp; Secure</span>
            </div>
            <div className="absolute bottom-12 -right-4 bg-white border border-gray-100 rounded-2xl px-4 py-3">
              <div className="text-xs text-gray-400 mb-1">Encryption</div>
              <div className="text-sm font-bold text-gray-900">AES-256</div>
            </div>
          </div>
        </div>

        {/* Features grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f) => (
            <div
              key={f.title}
              className="bg-[#f8f8f6] rounded-2xl p-6 md:p-8 border border-gray-100"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-green-400/10 rounded-xl mb-4">
                <i className={`${f.icon} text-green-500 text-lg w-5 h-5 flex items-center justify-center`} />
              </div>
              <h4 className="font-bold text-gray-900 text-base mb-2">{f.title}</h4>
              <p className="text-gray-500 text-sm leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
